// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Gallery Styles - CSS Module */
/* Dark mode by default to match image-generator app */
/* Sidebar Container */
.u693Xg4t0Q1cjPkoAhj6 {
  position: fixed;
  right: 0;
  top: 80px;
  height: calc(100vh - 98px);
  width: 280px; /* Default width */
  background-color: #1f2937; /* gray-800 - dark background */
  color: #f3f4f6; /* gray-100 - light text */
  border-left: 1px solid #374151; /* gray-700 */
  border-top: 1px solid #374151; /* gray-700 */
  transition: transform 0.3s ease;
  display: flex;
  flex-direction: column;
  z-index: 40;
  box-shadow: -2px 0 10px rgba(0, 0, 0, 0.3);
  overflow: visible; /* Ensure toggle button outside sidebar is accessible */
}

/* Collapsed State */
.Fo3BzBV0Dz4T4o3TBPvL {
  transform: translateX(100%); /* Completely hide the sidebar */
}

/* Toggle Button */
.gRKNMIMa1mqqhdAGN5sD {
  position: fixed;
  right: 0;
  top: 80px;
  width: 55px;
  height: 55px;
  background-color: #1f2937; /* gray-800 - dark background */
  color: #d1d5db; /* gray-300 - light icon */
  border: 1px solid #374151; /* gray-700 */
  border-right: none;
  border-radius: 4px 0 0 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: -2px 0 5px rgba(0, 0, 0, 0.3);
  z-index: 50; /* Ensure button is above other elements */
  box-sizing: border-box; /* Include border in width/height */
  padding: 0; /* Remove any default padding */
  margin: 0; /* Remove any default margin */
  -webkit-appearance: none; /* Remove default browser button styling */
  appearance: none;
  outline: none; /* We'll handle focus states ourselves */
}

.gRKNMIMa1mqqhdAGN5sD::before {
  content: "";
  position: absolute;
  top: -4px; /* Extend click area beyond visible button */
  left: -4px;
  right: -4px;
  bottom: -4px;
  /* This invisible area extends the clickable zone */
}

.gRKNMIMa1mqqhdAGN5sD:hover {
  background-color: #374151; /* gray-700 */
  color: #f3f4f6; /* gray-100 - brighter on hover */
}

.gRKNMIMa1mqqhdAGN5sD:active {
  background-color: #4b5563; /* gray-600 */
}

.gRKNMIMa1mqqhdAGN5sD svg {
  pointer-events: none; /* Ensure clicks pass through to the button */
  width: 30px;
  height: 30px;
  flex-shrink: 0; /* Prevent SVG from shrinking */
  position: relative; /* Ensure SVG is above pseudo-element */
  z-index: 1;
}

/* Header Section */
.JfQWQYmOOVd7BQAKApDW {
  padding: 8px;
  height: 55px;
  border-bottom: 1px solid #374151; /* gray-700 */
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0; /* Prevent header from shrinking */
  background-color: #1f2937; /* gray-800 */
}

.RF5HOp2put5oBqTYSZRH {
  font-size: 1rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  color: #f3f4f6; /* gray-100 */
}

.KHwoK_WSvUG3exTs_hqA {
  background-color: #4f46e5; /* indigo-600 */
  color: white;
  border-radius: 9999px;
  padding: 0.125rem 0.375rem;
  font-size: 0.75rem;
  margin-left: 0.5rem;
}

/* Main Content Area (Grid) */
.DMW4g4dyu2wHLyOtntu2 {
  flex-grow: 1; /* Allow content to take available space */
  overflow-y: auto; /* Enable scrolling */
  padding: 0.5rem; /* Consistent padding around the grid */
  display: grid;
  grid-template-columns: repeat(2, 1fr) !important; /* Always 2 columns - !important needed to override Tailwind */
  gap: 0.5rem; /* Single gap property for rows and columns */
  align-content: start; /* Align grid rows to the start */
  background-color: #111827; /* gray-900 - darker background for content area */
}

/* Individual Gallery Item */
.bF121O2dPPj2z0bigBB9 {
  position: relative;
  aspect-ratio: 1/1; /* Maintain square aspect ratio */
  border-radius: 0.375rem;
  overflow: hidden; /* Clip image to rounded corners */
  border: 1px solid #374151; /* gray-700 */
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
  transition: transform 0.2s, box-shadow 0.2s;
  background-color: #1f2937; /* gray-800 */
}

.bF121O2dPPj2z0bigBB9:hover {
  transform: scale(1.03);
  z-index: 1; /* Bring hovered item to front */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.5);
}

/* Image within Gallery Item */
.bF121O2dPPj2z0bigBB9 img {
  display: block; /* Remove potential inline spacing */
  width: 100%;
  height: 100%;
  object-fit: cover; /* Cover the item area */
  margin: 0; /* Ensure no extra margins */
}

/* Video within Gallery Item */
.bF121O2dPPj2z0bigBB9 video {
  display: block; /* Remove potential inline spacing */
  width: 100%;
  height: 100%;
  object-fit: cover; /* Cover the item area */
  margin: 0; /* Ensure no extra margins */
}

/* Overlay for buttons (appears on hover) */
.srMjCCLKjuZQPI1opIOJ {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0);
  opacity: 0;
  transition: opacity 0.2s ease, background-color 0.2s ease;
  z-index: 1;
}

.bF121O2dPPj2z0bigBB9:hover .srMjCCLKjuZQPI1opIOJ {
  background-color: rgba(0, 0, 0, 0.4);
  opacity: 1;
}

/* Action Buttons */
.cgRUy9rGmH49ghuCWwIG {
  margin: 0 0.25rem;
  border-radius: 9999px;
  padding: 0.5rem;
  color: white;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.3);
  transition: background-color 0.2s ease;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.cgRUy9rGmH49ghuCWwIG svg {
  width: 1.25rem;
  height: 1.25rem;
}

.bC9RWoxKoRcMMiGIa83U {
  background-color: #2563eb; /* blue-600 */
}

.bC9RWoxKoRcMMiGIa83U:hover {
  background-color: #1d4ed8; /* blue-700 */
}

.kdGPCZtBLVArOfczii0e {
  background-color: #dc2626; /* red-600 */
}

.kdGPCZtBLVArOfczii0e:hover {
  background-color: #b91c1c; /* red-700 */
}

/* Item details label (bottom) */
.byT_QLzAKY_d9NwQCM_q {
  pointer-events: none;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.6);
  padding: 0.25rem;
  font-size: 0.75rem;
  color: white;
  opacity: 0;
  transition: opacity 0.2s ease;
}

.bF121O2dPPj2z0bigBB9:hover .byT_QLzAKY_d9NwQCM_q {
  opacity: 1;
}

.byT_QLzAKY_d9NwQCM_q p {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: center;
  margin: 0;
}

/* Footer Section */
.hvUHlg7u00Kqv7fZ4HCs {
  padding: 0.75rem;
  border-top: 1px solid #374151; /* gray-700 */
  background-color: #1f2937; /* gray-800 */
  flex-shrink: 0; /* Prevent footer from shrinking */
}

/* Clear Button */
.VZXO4bnmFsHY5GMb77pM {
  width: 100%;
  background-color: #ef4444;
  color: white;
  padding: 0.5rem 1rem;
  border: none;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s, transform 0.1s;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.VZXO4bnmFsHY5GMb77pM:focus {
  outline: 2px solid var(--primary-light); /* Assuming --primary-light defined */
  outline-offset: 2px;
}

.VZXO4bnmFsHY5GMb77pM:hover {
  background-color: #dc2626;
}

.VZXO4bnmFsHY5GMb77pM:active {
  transform: scale(0.98);
}

/* Modal Styling - Redesigned */
.g1v4c0QJZuXTEGI3oi3J {
  position: fixed;
  inset: 0; /* Replaces top, left, right, bottom */
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.5); /* Semi-transparent backdrop */
  backdrop-filter: blur(4px);
  padding: 1rem; /* Padding around the modal content */
  overflow-y: auto; /* Allow scrolling if modal content is too tall */
}

.vQX6oNPCtf6U3OjSXSkg {
  background: #1f2937; /* gray-800 - dark background */
  border-radius: 0.5rem;
  border: 1px solid #374151; /* gray-700 */
  width: auto; /* Let content determine width */
  max-width: 90vw; /* Max width */
  max-height: 90vh; /* Max height */
  display: flex;
  flex-direction: column;
  overflow: hidden; /* Clip content to rounded corners */
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.5);
  position: relative; /* For positioning close button */
}

.jvfONg8oF7j7qNZOiKpM {
  display: flex;
  justify-content: space-between; /* Title on left, close button on right */
  align-items: center;
  padding: 0.75rem 1rem;
  border-bottom: 1px solid #374151; /* gray-700 */
  flex-shrink: 0;
  background-color: #1f2937; /* gray-800 */
}

.xuL252c7ss2e0dh9CwBv {
  font-size: 1.125rem;
  font-weight: 600;
  color: #f3f4f6; /* gray-100 */
  margin: 0;
}

.LkBjpVYxAOrEVZqKfCRq {
  background: none;
  border: none;
  font-size: 1.5rem;
  line-height: 1;
  cursor: pointer;
  color: #d1d5db; /* gray-300 */
  padding: 0.25rem;
}

.LkBjpVYxAOrEVZqKfCRq:hover {
  color: #f3f4f6; /* gray-100 - brighter on hover */
}

/* Media Container - holds media and overlay */
.h30xJG8gRC_MidTdMSag {
  position: relative;
  flex-grow: 1;
  min-height: 0; /* Important for flex children */
  background-color: #111827; /* gray-900 - darker background for media */
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

/* Navigation Buttons - positioned outside modal content */
.TyFm87LlsZU1YhWk7qDK {
  position: fixed;
  top: 50%;
  transform: translateY(-50%);
  background-color: rgba(31, 41, 55, 0.9); /* gray-800 with transparency */
  color: #d1d5db; /* gray-300 */
  border: 1px solid rgba(75, 85, 99, 0.9); /* gray-600 with transparency */
  border-radius: 9999px;
  width: 3.5rem;
  height: 3.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  backdrop-filter: blur(8px);
  z-index: 101; /* Above modal which is z-index: 100 */
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);
}

.TyFm87LlsZU1YhWk7qDK svg {
  width: 1.75rem;
  height: 1.75rem;
  flex-shrink: 0;
}

.TyFm87LlsZU1YhWk7qDK:hover {
  background-color: rgb(55, 65, 81); /* gray-700 */
  color: #f3f4f6; /* gray-100 */
  border-color: rgb(107, 114, 128);
  transform: translateY(-50%) scale(1.1);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.5);
}

.TyFm87LlsZU1YhWk7qDK:active {
  transform: translateY(-50%) scale(0.98);
}

._PpneJN3PMUAmolqNEtB {
  left: calc(50% - 47vw); /* Position outside left edge of modal */
}

._PpneJN3PMUAmolqNEtB:hover {
  transform: translateY(-50%) translateX(-0.25rem) scale(1.1);
}

.uwSO5ZnkzXmGS7QfMogE {
  right: calc(50% - 47vw); /* Position outside right edge of modal */
}

.uwSO5ZnkzXmGS7QfMogE:hover {
  transform: translateY(-50%) translateX(0.25rem) scale(1.1);
}

.cQFaVTV8uvxBw0GSAtM0 {
  width: 100%;
  flex-grow: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  min-height: 0; /* Important for flex children */
}

.cQFaVTV8uvxBw0GSAtM0 img {
  display: block;
  max-width: 100%;
  max-height: calc(90vh - 12rem); /* 90vh modal - header - actions - padding */
  width: auto;
  height: auto;
  object-fit: contain; /* Fit without cropping */
}

.cQFaVTV8uvxBw0GSAtM0 video {
  display: block;
  max-width: 100%;
  max-height: calc(90vh - 15rem); /* 90vh modal - header - actions - padding - video controls */
  width: auto;
  height: auto;
  object-fit: contain; /* Fit without cropping */
}

/* Metadata Overlay - positioned over media at TOP */
.NcdSGB81wkt66lHNkHOf {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.5); /* 50% transparent */
  backdrop-filter: blur(8px);
  padding: 1rem;
  padding-top: 3.5rem; /* Space for toggle button */
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  max-height: 60%;
  overflow-y: auto;
  pointer-events: none; /* Allow clicks through empty areas */
}

.NcdSGB81wkt66lHNkHOf > * {
  pointer-events: auto; /* Re-enable clicks on content */
}

/* Overlay Prompt Section */
.ZTKPdXXAahZczCAxtr2Q {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.stie_bhvy0riSBEYYkDF {
  font-size: 0.75rem;
  font-weight: 600;
  color: #a5b4fc; /* indigo-300 */
  margin: 0;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.ZTc89YP4KvkZH6TUOu8w {
  font-size: 0.875rem;
  color: #f3f4f6; /* gray-100 */
  line-height: 1.5;
  max-height: 4rem;
  overflow-y: auto;
  padding: 0.5rem;
  background-color: rgba(55, 65, 81, 0.8); /* gray-700 with transparency */
  border-radius: 0.375rem;
  border: 1px solid rgba(75, 85, 99, 0.8); /* gray-600 with transparency */
  white-space: pre-wrap;
  word-break: break-word;
}

/* Overlay Metadata Row */
.m3MBj14wuVmY5fwsVO15 {
  display: flex;
  gap: 0.75rem;
  overflow-x: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(75, 85, 99, 0.8) transparent;
}

.m3MBj14wuVmY5fwsVO15::-webkit-scrollbar {
  height: 6px;
}

.m3MBj14wuVmY5fwsVO15::-webkit-scrollbar-track {
  background: transparent;
}

.m3MBj14wuVmY5fwsVO15::-webkit-scrollbar-thumb {
  background-color: rgba(75, 85, 99, 0.8); /* gray-600 with transparency */
  border-radius: 6px;
}

.m3MBj14wuVmY5fwsVO15::-webkit-scrollbar-thumb:hover {
  background-color: rgba(107, 114, 128, 0.8); /* gray-500 with transparency */
}

/* Toggle Button for Metadata */
.yPLX7DGYtP45C4Ie5p0n {
  position: absolute;
  top: 1rem;
  right: 1rem;
  padding: 0.5rem 0.75rem;
  background-color: rgba(31, 41, 55, 0.8); /* gray-800 with transparency */
  color: #d1d5db; /* gray-300 */
  border: 1px solid rgba(75, 85, 99, 0.8); /* gray-600 with transparency */
  border-radius: 0.375rem;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  backdrop-filter: blur(4px);
  z-index: 10;
  font-size: 0.875rem;
  font-weight: 500;
  white-space: nowrap;
}

.yPLX7DGYtP45C4Ie5p0n svg {
  width: 1.25rem;
  height: 1.25rem;
  flex-shrink: 0;
}

.yPLX7DGYtP45C4Ie5p0n span {
  line-height: 1;
}

.yPLX7DGYtP45C4Ie5p0n:hover {
  background-color: rgba(55, 65, 81, 0.9); /* gray-700 */
  color: #f3f4f6; /* gray-100 */
  border-color: rgba(107, 114, 128, 0.9);
  transform: scale(1.05);
}

.yPLX7DGYtP45C4Ie5p0n:active {
  transform: scale(0.95);
}

/* Metadata Item - used in overlay */
.ORJbs82e_1fSV2x5zARg {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  padding: 0.75rem;
  background-color: rgba(55, 65, 81, 0.8); /* gray-700 with transparency */
  border: 1px solid rgba(75, 85, 99, 0.8); /* gray-600 with transparency */
  border-radius: 0.375rem;
  min-width: 120px;
  flex-shrink: 0;
}

.ORJbs82e_1fSV2x5zARg .xXVfOOdLR6J1h6Q2O67F {
  font-size: 0.75rem;
  font-weight: 600;
  color: #a5b4fc; /* indigo-300 */
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.ORJbs82e_1fSV2x5zARg .XMWkkVxK3gLmw8zVVbct {
  font-size: 0.875rem;
  color: #e5e7eb; /* gray-200 */
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.z9umo3x9CUJ8uxrsBNwb {
  width: 1.25rem;
  height: 1.25rem;
  object-fit: contain;
  flex-shrink: 0;
}

.zPddSsC28flvELSTIFne {
  font-size: 0.875rem;
  color: #93c5fd; /* blue-300 */
  font-weight: 500;
  text-decoration: none;
  transition: color 0.15s ease;
}
.zPddSsC28flvELSTIFne:hover {
  color: #60a5fa; /* blue-400 */
  text-decoration: underline;
}

/* Modal Actions - Button container */
.bHwQLZ6mfk3IQ4F0swUn {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  background-color: #1f2937; /* gray-800 */
  border-top: 1px solid #374151; /* gray-700 */
  gap: 1rem;
  flex-shrink: 0; /* Prevent actions bar from shrinking or overlapping */
}

.MWeiEDKBrFro5lXcQAYx {
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
  justify-content: flex-end;
  flex: 1;
}

.GDWiTEq33hNhp12VpeOU {
  padding: 0.5rem 1rem;
  border: none;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
}

/* Delete Button - Small trashcan on the left */
.f4xNYswsiNcZn5Ywvy8b {
  padding: 0.5rem;
  background-color: transparent;
  color: #9ca3af; /* gray-400 */
  border: 1px solid #4b5563; /* gray-600 */
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.f4xNYswsiNcZn5Ywvy8b svg {
  width: 1.25rem;
  height: 1.25rem;
}

.f4xNYswsiNcZn5Ywvy8b:hover {
  background-color: #dc2626; /* red-600 */
  color: white;
  border-color: #dc2626;
  transform: scale(1.05);
}

.f4xNYswsiNcZn5Ywvy8b:active {
  transform: scale(0.95);
}

/* Primary Button - Most important (Download) */
.vr82YOIjL1F4mDubN3bV {
  background-color: #4f46e5; /* indigo-600 */
  color: white;
}

.vr82YOIjL1F4mDubN3bV:hover {
  background-color: #4338ca; /* indigo-700 */
  transform: translateY(-1px);
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.3);
}

.vr82YOIjL1F4mDubN3bV:active {
  transform: translateY(0);
}

/* Secondary Buttons - Less important actions */
.I8tZpsqJiZEnWt7pX9Na {
  background-color: #374151; /* gray-700 */
  color: #e5e7eb; /* gray-200 */
  border: 1px solid #4b5563; /* gray-600 */
}

.I8tZpsqJiZEnWt7pX9Na:hover {
  background-color: #4b5563; /* gray-600 */
  color: white;
  border-color: #6b7280;
}

.I8tZpsqJiZEnWt7pX9Na:active {
  background-color: #6b7280; /* gray-500 */
}

/* Light mode overrides (optional - for Storybook or future light mode support) */
.EAY7isNkuFcXWoClR_C6 .u693Xg4t0Q1cjPkoAhj6 {
  background-color: white;
  color: #1f2937;
  border-left-color: #4b5563;
  border-top-color: #4b5563;
}

.EAY7isNkuFcXWoClR_C6 .gRKNMIMa1mqqhdAGN5sD {
  background-color: white;
  color: #4b5563;
  border-color: #e5e7eb;
}

.EAY7isNkuFcXWoClR_C6 .JfQWQYmOOVd7BQAKApDW {
  background-color: white;
  border-bottom-color: #e5e7eb;
}

.EAY7isNkuFcXWoClR_C6 .RF5HOp2put5oBqTYSZRH {
  color: #1f2937;
}

.EAY7isNkuFcXWoClR_C6 .DMW4g4dyu2wHLyOtntu2 {
  background-color: #f9fafb;
}

.EAY7isNkuFcXWoClR_C6 .hvUHlg7u00Kqv7fZ4HCs {
  background-color: #f9fafb;
  border-top-color: #e5e7eb;
}

.EAY7isNkuFcXWoClR_C6 .vQX6oNPCtf6U3OjSXSkg {
  background: white;
  border-color: #e5e7eb;
}

.EAY7isNkuFcXWoClR_C6 .jvfONg8oF7j7qNZOiKpM {
  background-color: white;
  border-bottom-color: #e5e7eb;
}

.EAY7isNkuFcXWoClR_C6 .xuL252c7ss2e0dh9CwBv {
  color: #1f2937;
}

.EAY7isNkuFcXWoClR_C6 .LkBjpVYxAOrEVZqKfCRq {
  color: #6b7280;
}

.EAY7isNkuFcXWoClR_C6 .h30xJG8gRC_MidTdMSag {
  background-color: #f9fafb;
}

.EAY7isNkuFcXWoClR_C6 .NcdSGB81wkt66lHNkHOf {
  background-color: rgba(255, 255, 255, 0.5); /* 50% transparent white */
}

.EAY7isNkuFcXWoClR_C6 .stie_bhvy0riSBEYYkDF {
  color: #4f46e5; /* indigo-600 */
}

.EAY7isNkuFcXWoClR_C6 .ZTc89YP4KvkZH6TUOu8w {
  background-color: rgba(243, 244, 246, 0.9);
  border-color: rgba(229, 231, 235, 0.9);
  color: #1f2937;
}

.EAY7isNkuFcXWoClR_C6 .m3MBj14wuVmY5fwsVO15 {
  scrollbar-color: rgba(229, 231, 235, 0.8) transparent;
}

.EAY7isNkuFcXWoClR_C6 .m3MBj14wuVmY5fwsVO15::-webkit-scrollbar-thumb {
  background-color: rgba(229, 231, 235, 0.8);
}

.EAY7isNkuFcXWoClR_C6 .m3MBj14wuVmY5fwsVO15::-webkit-scrollbar-thumb:hover {
  background-color: rgba(209, 213, 219, 0.8);
}

.EAY7isNkuFcXWoClR_C6 .ORJbs82e_1fSV2x5zARg {
  background-color: rgba(243, 244, 246, 0.9);
  border-color: rgba(229, 231, 235, 0.9);
}

.EAY7isNkuFcXWoClR_C6 .ORJbs82e_1fSV2x5zARg .xXVfOOdLR6J1h6Q2O67F {
  color: #4f46e5; /* indigo-600 */
}

.EAY7isNkuFcXWoClR_C6 .ORJbs82e_1fSV2x5zARg .XMWkkVxK3gLmw8zVVbct {
  color: #374151;
}

.EAY7isNkuFcXWoClR_C6 .yPLX7DGYtP45C4Ie5p0n {
  background-color: rgba(255, 255, 255, 0.8);
  color: #6b7280;
  border-color: rgba(229, 231, 235, 0.8);
}

.EAY7isNkuFcXWoClR_C6 .yPLX7DGYtP45C4Ie5p0n:hover {
  background-color: rgba(243, 244, 246, 0.9);
  color: #1f2937;
  border-color: rgba(209, 213, 219, 0.9);
}

.EAY7isNkuFcXWoClR_C6 .bHwQLZ6mfk3IQ4F0swUn {
  background-color: white;
  border-top-color: #e5e7eb;
}

.EAY7isNkuFcXWoClR_C6 .TyFm87LlsZU1YhWk7qDK {
  background-color: rgba(255, 255, 255, 0.95);
  color: #6b7280; /* gray-500 */
  border-color: rgba(229, 231, 235, 0.95);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.EAY7isNkuFcXWoClR_C6 .TyFm87LlsZU1YhWk7qDK:hover {
  background-color: rgb(249, 250, 251); /* gray-50 */
  color: #1f2937;
  border-color: rgb(209, 213, 219);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
}

.EAY7isNkuFcXWoClR_C6 .f4xNYswsiNcZn5Ywvy8b {
  color: #6b7280;
  border-color: #e5e7eb;
}

.EAY7isNkuFcXWoClR_C6 .f4xNYswsiNcZn5Ywvy8b:hover {
  background-color: #dc2626;
  color: white;
  border-color: #dc2626;
}

.EAY7isNkuFcXWoClR_C6 .I8tZpsqJiZEnWt7pX9Na {
  background-color: #f3f4f6;
  color: #374151;
  border-color: #e5e7eb;
}

.EAY7isNkuFcXWoClR_C6 .I8tZpsqJiZEnWt7pX9Na:hover {
  background-color: #e5e7eb;
  color: #1f2937;
  border-color: #d1d5db;
}

/* Adjust media query for modal */
@media (max-width: 768px) {
  .g1v4c0QJZuXTEGI3oi3J {
    padding: 0.5rem;
  }
  .vQX6oNPCtf6U3OjSXSkg {
    max-width: 95vw; /* Slightly more width on mobile */
    max-height: 95vh;
    border-radius: 0.25rem; /* Slightly smaller radius */
  }
  .cQFaVTV8uvxBw0GSAtM0 {
    padding: 0.5rem;
  }
  .cQFaVTV8uvxBw0GSAtM0 img {
    max-height: calc(95vh - 11rem); /* Adjust for mobile: 95vh - smaller padding */
  }
  .cQFaVTV8uvxBw0GSAtM0 video {
    max-height: calc(95vh - 14rem); /* Adjust for mobile: 95vh - smaller padding - video controls */
  }
  .TyFm87LlsZU1YhWk7qDK {
    width: 2.5rem;
    height: 2.5rem;
  }
  .TyFm87LlsZU1YhWk7qDK svg {
    width: 1.25rem;
    height: 1.25rem;
  }
  ._PpneJN3PMUAmolqNEtB {
    left: 0.5rem; /* On mobile, position close to edge */
  }
  .uwSO5ZnkzXmGS7QfMogE {
    right: 0.5rem; /* On mobile, position close to edge */
  }
  ._PpneJN3PMUAmolqNEtB:hover {
    transform: translateY(-50%) translateX(-0.125rem) scale(1.05);
  }
  .uwSO5ZnkzXmGS7QfMogE:hover {
    transform: translateY(-50%) translateX(0.125rem) scale(1.05);
  }
}
/* Empty State */
.rTP48IdTPTQ3nxRoGwnE {
  color: #9ca3af; /* gray-400 - lighter for dark mode */
  text-align: center;
  padding: 2rem 1rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%; /* Take full height of container */
  grid-column: 1/-1; /* Span all grid columns */
}

.cDkmd5TQlO7sGtWWoXWq {
  opacity: 0.5;
  margin-bottom: 0.5rem;
}

/* Custom Scrollbar */
.DMW4g4dyu2wHLyOtntu2::-webkit-scrollbar {
  width: 6px;
}

.DMW4g4dyu2wHLyOtntu2::-webkit-scrollbar-track {
  background: #1f2937; /* gray-800 */
}

.DMW4g4dyu2wHLyOtntu2::-webkit-scrollbar-thumb {
  background-color: #4b5563; /* gray-600 */
  border-radius: 6px;
}

.DMW4g4dyu2wHLyOtntu2::-webkit-scrollbar-thumb:hover {
  background-color: #6b7280; /* gray-500 */
}

/* Mobile Adjustments */
@media (max-width: 640px) {
  .u693Xg4t0Q1cjPkoAhj6 {
    width: 240px; /* narrow sidebar on mobile */
  }
  .DMW4g4dyu2wHLyOtntu2 {
    /* Always 2 columns - inherited from base .content style */
    padding: 0.5rem;
    gap: 0.5rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/shared/gallery/components/Gallery.module.scss"],"names":[],"mappings":"AAAA,gCAAA;AACA,sDAAA;AAEA,sBAAA;AACA;EACE,eAAA;EACA,QAAA;EACA,SAAA;EACA,0BAAA;EACA,YAAA,EAAA,kBAAA;EACA,yBAAA,EAAA,+BAAA;EACA,cAAA,EAAA,0BAAA;EACA,8BAAA,EAAA,aAAA;EACA,6BAAA,EAAA,aAAA;EACA,+BAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,0CAAA;EACA,iBAAA,EAAA,uDAAA;AAAF;;AAGA,oBAAA;AACA;EACE,2BAAA,EAAA,gCAAA;AAAF;;AAGA,kBAAA;AACA;EACE,eAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA,EAAA,+BAAA;EACA,cAAA,EAAA,0BAAA;EACA,yBAAA,EAAA,aAAA;EACA,kBAAA;EACA,0BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,yBAAA;EACA,yCAAA;EACA,WAAA,EAAA,0CAAA;EACA,sBAAA,EAAA,mCAAA;EACA,UAAA,EAAA,+BAAA;EACA,SAAA,EAAA,8BAAA;EACA,wBAAA,EAAA,0CAAA;EACA,gBAAA;EACA,aAAA,EAAA,wCAAA;AAAF;;AAGA;EACE,WAAA;EACA,kBAAA;EACA,SAAA,EAAA,4CAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,mDAAA;AAAF;;AAGA;EACE,yBAAA,EAAA,aAAA;EACA,cAAA,EAAA,iCAAA;AAAF;;AAGA;EACE,yBAAA,EAAA,aAAA;AAAF;;AAGA;EACE,oBAAA,EAAA,6CAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA,EAAA,+BAAA;EACA,kBAAA,EAAA,uCAAA;EACA,UAAA;AAAF;;AAGA,mBAAA;AACA;EACE,YAAA;EACA,YAAA;EACA,gCAAA,EAAA,aAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,cAAA,EAAA,kCAAA;EACA,yBAAA,EAAA,aAAA;AAAF;;AAGA;EACE,eAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA,EAAA,aAAA;AAAF;;AAGA;EACE,yBAAA,EAAA,eAAA;EACA,YAAA;EACA,qBAAA;EACA,0BAAA;EACA,kBAAA;EACA,mBAAA;AAAF;;AAGA,6BAAA;AACA;EACE,YAAA,EAAA,0CAAA;EACA,gBAAA,EAAA,qBAAA;EACA,eAAA,EAAA,uCAAA;EACA,aAAA;EACA,gDAAA,EAGc,8DAAA;EACd,WAAA,EAAA,6CAAA;EACA,oBAAA,EAAA,iCAAA;EACA,yBAAA,EAAA,kDAAA;AAHF;;AAMA,4BAAA;AACA;EACE,kBAAA;EACA,iBAAA,EAAA,iCAAA;EACA,uBAAA;EACA,gBAAA,EAAA,kCAAA;EACA,yBAAA,EAAA,aAAA;EACA,wCAAA;EACA,2CACE;EAEF,yBAAA,EAAA,aAAA;AALF;;AAQA;EACE,sBAAA;EACA,UAAA,EAAA,gCAAA;EACA,wCAAA;AALF;;AAQA,8BAAA;AACA;EACE,cAAA,EAAA,oCAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA,EAAA,wBAAA;EACA,SAAA,EAAA,4BAAA;AALF;;AAQA,8BAAA;AACA;EACE,cAAA,EAAA,oCAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA,EAAA,wBAAA;EACA,SAAA,EAAA,4BAAA;AALF;;AAQA,2CAAA;AACA;EACE,kBAAA;EACA,QAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kCAAA;EACA,UAAA;EACA,yDACE;EAEF,UAAA;AAPF;;AAUA;EACE,oCAAA;EACA,UAAA;AAPF;;AAUA,mBAAA;AACA;EACE,iBAAA;EACA,qBAAA;EACA,eAAA;EACA,YAAA;EACA,+CAAA;EACA,sCAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAPF;;AAUA;EACE,cAAA;EACA,eAAA;AAPF;;AAUA;EACE,yBAAA,EAAA,aAAA;AAPF;;AAUA;EACE,yBAAA,EAAA,aAAA;AAPF;;AAUA;EACE,yBAAA,EAAA,YAAA;AAPF;;AAUA;EACE,yBAAA,EAAA,YAAA;AAPF;;AAUA,gCAAA;AACA;EACE,oBAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,oCAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,UAAA;EACA,6BAAA;AAPF;;AAUA;EACE,UAAA;AAPF;;AAUA;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,SAAA;AAPF;;AAUA,mBAAA;AACA;EACE,gBAAA;EACA,6BAAA,EAAA,aAAA;EACA,yBAAA,EAAA,aAAA;EACA,cAAA,EAAA,kCAAA;AAPF;;AAUA,iBAAA;AACA;EACE,WAAA;EACA,yBAAA;EACA,YAAA;EACA,oBAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,iDACE;EAEF,yCAAA;AATF;;AAYA;EACE,uCAAA,EAAA,qCAAA;EACA,mBAAA;AATF;;AAYA;EACE,yBAAA;AATF;;AAYA;EACE,sBAAA;AATF;;AAYA,+BAAA;AACA;EACE,eAAA;EACA,QAAA,EAAA,sCAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,oCAAA,EAAA,8BAAA;EACA,0BAAA;EACA,aAAA,EAAA,qCAAA;EACA,gBAAA,EAAA,iDAAA;AATF;;AAYA;EACE,mBAAA,EAAA,+BAAA;EACA,qBAAA;EACA,yBAAA,EAAA,aAAA;EACA,WAAA,EAAA,gCAAA;EACA,eAAA,EAAA,cAAA;EACA,gBAAA,EAAA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA,EAAA,oCAAA;EACA,yCAAA;EACA,kBAAA,EAAA,iCAAA;AATF;;AAYA;EACE,aAAA;EACA,8BAAA,EAAA,yCAAA;EACA,mBAAA;EACA,qBAAA;EACA,gCAAA,EAAA,aAAA;EACA,cAAA;EACA,yBAAA,EAAA,aAAA;AATF;;AAYA;EACE,mBAAA;EACA,gBAAA;EACA,cAAA,EAAA,aAAA;EACA,SAAA;AATF;;AAYA;EACE,gBAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA,EAAA,aAAA;EACA,gBAAA;AATF;;AAYA;EACE,cAAA,EAAA,iCAAA;AATF;;AAYA,8CAAA;AACA;EACE,kBAAA;EACA,YAAA;EACA,aAAA,EAAA,gCAAA;EACA,yBAAA,EAAA,2CAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;AATF;;AAYA,0DAAA;AACA;EACE,eAAA;EACA,QAAA;EACA,2BAAA;EACA,uCAAA,EAAA,+BAAA;EACA,cAAA,EAAA,aAAA;EACA,uCAAA,EAAA,+BAAA;EACA,qBAAA;EACA,aAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,yBAAA;EACA,0BAAA;EACA,YAAA,EAAA,sCAAA;EACA,yCAAA;AATF;;AAYA;EACE,cAAA;EACA,eAAA;EACA,cAAA;AATF;;AAYA;EACE,iCAAA,EAAA,aAAA;EACA,cAAA,EAAA,aAAA;EACA,gCAAA;EACA,sCAAA;EACA,yCAAA;AATF;;AAYA;EACE,uCAAA;AATF;;AAYA;EACE,sBAAA,EAAA,wCAAA;AATF;;AAYA;EACE,2DAAA;AATF;;AAYA;EACE,uBAAA,EAAA,yCAAA;AATF;;AAYA;EACE,0DAAA;AATF;;AAYA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,aAAA,EAAA,gCAAA;AATF;;AAYA;EACE,cAAA;EACA,eAAA;EACA,8BAAA,EAAA,4CAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA,EAAA,yBAAA;AATF;;AAYA;EACE,cAAA;EACA,eAAA;EACA,8BAAA,EAEG,6DAAA;EACH,WAAA;EACA,YAAA;EACA,mBAAA,EAAA,yBAAA;AAXF;;AAcA,oDAAA;AACA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,oCAAA,EAAA,oBAAA;EACA,0BAAA;EACA,aAAA;EACA,mBAAA,EAAA,4BAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA,EAAA,qCAAA;AAXF;;AAcA;EACE,oBAAA,EAAA,gCAAA;AAXF;;AAcA,2BAAA;AACA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;AAXF;;AAcA;EACE,kBAAA;EACA,gBAAA;EACA,cAAA,EAAA,eAAA;EACA,SAAA;EACA,yBAAA;EACA,sBAAA;AAXF;;AAcA;EACE,mBAAA;EACA,cAAA,EAAA,aAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,uCAAA,EAAA,+BAAA;EACA,uBAAA;EACA,uCAAA,EAAA,+BAAA;EACA,qBAAA;EACA,sBAAA;AAXF;;AAcA,yBAAA;AACA;EACE,aAAA;EACA,YAAA;EACA,gBAAA;EACA,qBAAA;EACA,kDAAA;AAXF;;AAcA;EACE,WAAA;AAXF;;AAcA;EACE,uBAAA;AAXF;;AAcA;EACE,uCAAA,EAAA,+BAAA;EACA,kBAAA;AAXF;;AAcA;EACE,0CAAA,EAAA,+BAAA;AAXF;;AAcA,+BAAA;AACA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,uBAAA;EACA,uCAAA,EAAA,+BAAA;EACA,cAAA,EAAA,aAAA;EACA,uCAAA,EAAA,+BAAA;EACA,uBAAA;EACA,eAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,0BAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;AAXF;;AAcA;EACE,cAAA;EACA,eAAA;EACA,cAAA;AAXF;;AAcA;EACE,cAAA;AAXF;;AAcA;EACE,uCAAA,EAAA,aAAA;EACA,cAAA,EAAA,aAAA;EACA,sCAAA;EACA,sBAAA;AAXF;;AAcA;EACE,sBAAA;AAXF;;AAcA,oCAAA;AACA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,gBAAA;EACA,uCAAA,EAAA,+BAAA;EACA,uCAAA,EAAA,+BAAA;EACA,uBAAA;EACA,gBAAA;EACA,cAAA;AAXF;;AAcA;EACE,kBAAA;EACA,gBAAA;EACA,cAAA,EAAA,eAAA;EACA,yBAAA;EACA,sBAAA;AAXF;;AAcA;EACE,mBAAA;EACA,cAAA,EAAA,aAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;AAXF;;AAcA;EACE,cAAA;EACA,eAAA;EACA,mBAAA;EACA,cAAA;AAXF;;AAcA;EACE,mBAAA;EACA,cAAA,EAAA,aAAA;EACA,gBAAA;EACA,qBAAA;EACA,4BAAA;AAXF;AAaE;EACE,cAAA,EAAA,aAAA;EACA,0BAAA;AAXJ;;AAeA,qCAAA;AACA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,aAAA;EACA,yBAAA,EAAA,aAAA;EACA,6BAAA,EAAA,aAAA;EACA,SAAA;EACA,cAAA,EAAA,sDAAA;AAZF;;AAeA;EACE,aAAA;EACA,WAAA;EACA,eAAA;EACA,yBAAA;EACA,OAAA;AAZF;;AAeA;EACE,oBAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,mBAAA;AAZF;;AAeA,+CAAA;AACA;EACE,eAAA;EACA,6BAAA;EACA,cAAA,EAAA,aAAA;EACA,yBAAA,EAAA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;AAZF;;AAeA;EACE,cAAA;EACA,eAAA;AAZF;;AAeA;EACE,yBAAA,EAAA,YAAA;EACA,YAAA;EACA,qBAAA;EACA,sBAAA;AAZF;;AAeA;EACE,sBAAA;AAZF;;AAeA,+CAAA;AACA;EACE,yBAAA,EAAA,eAAA;EACA,YAAA;AAZF;;AAeA;EACE,yBAAA,EAAA,eAAA;EACA,2BAAA;EACA,wCAAA;AAZF;;AAeA;EACE,wBAAA;AAZF;;AAeA,+CAAA;AACA;EACE,yBAAA,EAAA,aAAA;EACA,cAAA,EAAA,aAAA;EACA,yBAAA,EAAA,aAAA;AAZF;;AAeA;EACE,yBAAA,EAAA,aAAA;EACA,YAAA;EACA,qBAAA;AAZF;;AAeA;EACE,yBAAA,EAAA,aAAA;AAZF;;AAeA,iFAAA;AACA;EACE,uBAAA;EACA,cAAA;EACA,0BAAA;EACA,yBAAA;AAZF;;AAeA;EACE,uBAAA;EACA,cAAA;EACA,qBAAA;AAZF;;AAeA;EACE,uBAAA;EACA,4BAAA;AAZF;;AAeA;EACE,cAAA;AAZF;;AAeA;EACE,yBAAA;AAZF;;AAeA;EACE,yBAAA;EACA,yBAAA;AAZF;;AAeA;EACE,iBAAA;EACA,qBAAA;AAZF;;AAeA;EACE,uBAAA;EACA,4BAAA;AAZF;;AAeA;EACE,cAAA;AAZF;;AAeA;EACE,cAAA;AAZF;;AAeA;EACE,yBAAA;AAZF;;AAeA;EACE,0CAAA,EAAA,0BAAA;AAZF;;AAeA;EACE,cAAA,EAAA,eAAA;AAZF;;AAeA;EACE,0CAAA;EACA,sCAAA;EACA,cAAA;AAZF;;AAeA;EACE,qDAAA;AAZF;;AAeA;EACE,0CAAA;AAZF;;AAeA;EACE,0CAAA;AAZF;;AAeA;EACE,0CAAA;EACA,sCAAA;AAZF;;AAeA;EACE,cAAA,EAAA,eAAA;AAZF;;AAeA;EACE,cAAA;AAZF;;AAeA;EACE,0CAAA;EACA,cAAA;EACA,sCAAA;AAZF;;AAeA;EACE,0CAAA;EACA,cAAA;EACA,sCAAA;AAZF;;AAeA;EACE,uBAAA;EACA,yBAAA;AAZF;;AAeA;EACE,2CAAA;EACA,cAAA,EAAA,aAAA;EACA,uCAAA;EACA,0CAAA;AAZF;;AAeA;EACE,oCAAA,EAAA,YAAA;EACA,cAAA;EACA,gCAAA;EACA,yCAAA;AAZF;;AAeA;EACE,cAAA;EACA,qBAAA;AAZF;;AAeA;EACE,yBAAA;EACA,YAAA;EACA,qBAAA;AAZF;;AAeA;EACE,yBAAA;EACA,cAAA;EACA,qBAAA;AAZF;;AAeA;EACE,yBAAA;EACA,cAAA;EACA,qBAAA;AAZF;;AAeA,iCAAA;AACA;EACE;IACE,eAAA;EAZF;EAcA;IACE,eAAA,EAAA,kCAAA;IACA,gBAAA;IACA,sBAAA,EAAA,4BAAA;EAZF;EAcA;IACE,eAAA;EAZF;EAcA;IACE,8BAAA,EAEG,8CAAA;EAdL;EAgBA;IACE,8BAAA,EAEG,+DAAA;EAhBL;EAkBA;IACE,aAAA;IACA,cAAA;EAhBF;EAkBA;IACE,cAAA;IACA,eAAA;EAhBF;EAkBA;IACE,YAAA,EAAA,sCAAA;EAhBF;EAkBA;IACE,aAAA,EAAA,sCAAA;EAhBF;EAkBA;IACE,6DAAA;EAhBF;EAkBA;IACE,4DAAA;EAhBF;AACF;AAmBA,gBAAA;AACA;EACE,cAAA,EAAA,qCAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA,EAAA,kCAAA;EACA,iBAAA,EAAA,0BAAA;AAjBF;;AAoBA;EACE,YAAA;EACA,qBAAA;AAjBF;;AAoBA,qBAAA;AACA;EACE,UAAA;AAjBF;;AAoBA;EACE,mBAAA,EAAA,aAAA;AAjBF;;AAoBA;EACE,yBAAA,EAAA,aAAA;EACA,kBAAA;AAjBF;;AAoBA;EACE,yBAAA,EAAA,aAAA;AAjBF;;AAoBA,uBAAA;AACA;EACE;IACE,YAAA,EAAA,6BAAA;EAjBF;EAoBA;IACE,0DAAA;IACA,eAAA;IACA,WAAA;EAlBF;AACF","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sidebar": `u693Xg4t0Q1cjPkoAhj6`,
	"collapsed": `Fo3BzBV0Dz4T4o3TBPvL`,
	"toggle": `gRKNMIMa1mqqhdAGN5sD`,
	"header": `JfQWQYmOOVd7BQAKApDW`,
	"title": `RF5HOp2put5oBqTYSZRH`,
	"counter": `KHwoK_WSvUG3exTs_hqA`,
	"content": `DMW4g4dyu2wHLyOtntu2`,
	"item": `bF121O2dPPj2z0bigBB9`,
	"itemOverlay": `srMjCCLKjuZQPI1opIOJ`,
	"itemButton": `cgRUy9rGmH49ghuCWwIG`,
	"downloadBtn": `bC9RWoxKoRcMMiGIa83U`,
	"deleteBtn": `kdGPCZtBLVArOfczii0e`,
	"itemDetails": `byT_QLzAKY_d9NwQCM_q`,
	"footer": `hvUHlg7u00Kqv7fZ4HCs`,
	"clearBtn": `VZXO4bnmFsHY5GMb77pM`,
	"modal": `g1v4c0QJZuXTEGI3oi3J`,
	"modalContent": `vQX6oNPCtf6U3OjSXSkg`,
	"modalHeader": `jvfONg8oF7j7qNZOiKpM`,
	"modalTitle": `xuL252c7ss2e0dh9CwBv`,
	"modalCloseBtn": `LkBjpVYxAOrEVZqKfCRq`,
	"modalMediaContainer": `h30xJG8gRC_MidTdMSag`,
	"navButton": `TyFm87LlsZU1YhWk7qDK`,
	"navButtonPrev": `_PpneJN3PMUAmolqNEtB`,
	"navButtonNext": `uwSO5ZnkzXmGS7QfMogE`,
	"modalBody": `cQFaVTV8uvxBw0GSAtM0`,
	"metadataOverlay": `NcdSGB81wkt66lHNkHOf`,
	"overlayPromptSection": `ZTKPdXXAahZczCAxtr2Q`,
	"overlayPromptTitle": `stie_bhvy0riSBEYYkDF`,
	"overlayPromptText": `ZTc89YP4KvkZH6TUOu8w`,
	"overlayMetadataRow": `m3MBj14wuVmY5fwsVO15`,
	"metadataToggleBtn": `yPLX7DGYtP45C4Ie5p0n`,
	"metadataItem": `ORJbs82e_1fSV2x5zARg`,
	"metadataLabel": `xXVfOOdLR6J1h6Q2O67F`,
	"metadataValue": `XMWkkVxK3gLmw8zVVbct`,
	"modelLogo": `z9umo3x9CUJ8uxrsBNwb`,
	"metadataLink": `zPddSsC28flvELSTIFne`,
	"modalActions": `bHwQLZ6mfk3IQ4F0swUn`,
	"actionButtonGroup": `MWeiEDKBrFro5lXcQAYx`,
	"actionButton": `GDWiTEq33hNhp12VpeOU`,
	"deleteButton": `f4xNYswsiNcZn5Ywvy8b`,
	"primaryButton": `vr82YOIjL1F4mDubN3bV`,
	"secondaryButton": `I8tZpsqJiZEnWt7pX9Na`,
	"light": `EAY7isNkuFcXWoClR_C6`,
	"emptyState": `rTP48IdTPTQ3nxRoGwnE`,
	"emptyIcon": `cDkmd5TQlO7sGtWWoXWq`
};
export default ___CSS_LOADER_EXPORT___;
